import i18n from "../../i18n";
import { useDynamicContext } from "@dynamic-labs/sdk-react-core"
import { useEffect, useState } from "react";
import { useBrowserLocale } from "..";

type LocaleOption = {
    label: string;
    value: string;
}

const useLocaleSwitcher = () => {
    const browserLocale = useBrowserLocale();
    const [selectedOption, setSelectedOption] = useState<LocaleOption | undefined>(undefined);
    const { locale } = useDynamicContext();

    const options = [
        { label: 'EN', value: 'en' },
        { label: 'ES', value: 'es' },
        { label: 'PT', value: 'pt' },
    ];

    const getSelectedOption = (locale: string) => options.find(option => option.value === locale)

    useEffect(() => {
        if (browserLocale != null) {
            setSelectedOption(getSelectedOption(browserLocale));
            locale.changeLanguage(browserLocale);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [browserLocale]);

    const supportedLocales = ['en', 'es', 'pt']

    const handleOnClick = (option: LocaleOption) => {

        if (supportedLocales.includes(option.value)) {
            setSelectedOption(option);
            // switch dynamic locale
            locale.changeLanguage(option.value);
            // also update app locale
            i18n.changeLanguage(option.value);
        }
    };

    return {
        browserLocale,
        localeOptions: options,
        selectedOption,
        handleOnClick
    }
}

export default useLocaleSwitcher;